/**
 * §5.D — Les 22 écrans collaborateur, dans leurs groupes de navigation.
 * Cette liste est la source unique du menu ET de la table des routes :
 * un écran déclaré ici sans composant échoue au build, pas au clic.
 */
export type Ecran = {
  readonly cle: string;
  readonly titre: string;
  readonly resume: string;
  /** Écran réservé au gérant (`is_admin`). */
  readonly gerantSeul?: boolean;
};

export type Groupe = { readonly titre: string; readonly ecrans: readonly Ecran[] };

export const GROUPES: readonly Groupe[] = [
  {
    titre: "Synthèse",
    ecrans: [
      { cle: "tableau-de-bord", titre: "Tableau de bord", resume: "Notation, chaîne de traitement du mois, conformité par domaine" },
      { cle: "reporting", titre: "Reporting", resume: "Notation, anomalies, exports PDF / Word / Excel" },
      { cle: "diagnostic", titre: "Diagnostic financier", resume: "Analyse Vernimmen, Altman Z'', EVA" },
      { cle: "estimations", titre: "Estimations", resume: "Dû et déclarable sur les mois RÉELLEMENT tenus" },
    ],
  },
  {
    titre: "Dossier",
    ecrans: [
      { cle: "dossier-traitement", titre: "Dossier & traitement", resume: "Identité, imports balance et journal, traitement mensuel" },
      { cle: "consultation-client", titre: "Consultation client", resume: "Tout ce que le client a déposé et saisi" },
      { cle: "justificatifs", titre: "Justificatifs du journal", resume: "Rangés, introuvables, absents, et les pièces qu'aucune écriture ne réclame" },
      { cle: "audit-documentaire", titre: "Audit documentaire", resume: "Checklist partagée par toute l'équipe" },
      { cle: "lecture-automatique", titre: "Lecture automatique", resume: "Ce que le modèle a lu sur les PDF déposés — à confirmer avant tout usage" },
      { cle: "suivi-direct", titre: "Suivi en direct", resume: "60 dernières écritures, note interne", gerantSeul: true },
    ],
  },
  {
    titre: "Base comptable",
    ecrans: [
      { cle: "journal-ecritures", titre: "Journal des écritures", resume: "Écritures générées ou importées" },
      { cle: "balance", titre: "Balance générale", resume: "Format 6 colonnes MDC" },
      { cle: "grand-livre", titre: "Grand livre", resume: "Par compte, solde progressif" },
      { cle: "compte-resultat", titre: "Compte de résultat", resume: "Tous les SIG, XA à XI" },
      { cle: "bilan", titre: "Bilan", resume: "Actif / Passif avec contrôles B1 à B4" },
    ],
  },
  {
    titre: "Fiscal",
    ecrans: [
      { cle: "facturation-tva", titre: "Facturation & TVA", resume: "Registres FNE et achats, report de crédit" },
      { cle: "suivi-fiscal", titre: "Suivi fiscal", resume: "Une ligne par nature d'impôt, grille déclarative annuelle" },
      { cle: "obligations", titre: "Obligations", resume: "Checklist mensuelle filtrée par régime" },
      { cle: "analyse-releve", titre: "Analyse relevé", resume: "Lecture, catégorisation, bouclage, rapprochement, exposition, DEE" },
    ],
  },
  {
    titre: "Social",
    ecrans: [
      { cle: "paie", titre: "Paie", resume: "ITS, CNPS, CN, FDFP par salarié" },
      { cle: "personnel", titre: "Personnel", resume: "Inventaire, CNPS, contrats, visites médicales, échéances" },
    ],
  },
  {
    titre: "Relation",
    ecrans: [
      { cle: "interventions", titre: "Journal d'intervention", resume: "La preuve de diligence de l'agence" },
      { cle: "requetes", titre: "Requêtes client", resume: "Canal, délai, satisfaction" },
    ],
  },
] as const;

export const TOUS_LES_ECRANS = GROUPES.flatMap((g) => g.ecrans);
